import { render, staticRenderFns } from "./GuideItem.vue?vue&type=template&id=4003214e&scoped=true"
import script from "./GuideItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuideItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GuideItem.vue?vue&type=style&index=0&id=4003214e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4003214e",
  null
  
)

export default component.exports